import { supabase } from "@/lib/supabase";
import { callRpcResult } from "@/lib/api/rpc";

export type CleanupStatus = "queued" | "running" | "retrying" | "blocked" | "failed" | "completed";
export interface CatalogueCleanupJob {
  id: string;
  media_asset_id: string;
  status: CleanupStatus;
  attempts: number;
  last_error: string | null;
  created_at: string;
  completed_at: string | null;
}

/** RLS remains authoritative. This bounded view reports outstanding work only. */
export async function loadCatalogueCleanupJobs(orgId: string): Promise<CatalogueCleanupJob[]> {
  const { data, error } = await supabase.from("catalogue_media_cleanup_jobs")
    .select("id, media_asset_id, status, attempts, last_error, created_at, completed_at")
    .eq("org_id", orgId).neq("status", "completed").order("created_at").limit(100);
  if (error) throw new Error("Could not load media cleanup status.");
  return (data ?? []) as CatalogueCleanupJob[];
}

export async function retryCatalogueCleanup(orgId: string, jobId: string): Promise<void> {
  await callRpcResult("retry_catalogue_media_cleanup", { p_org_id: orgId, p_job_id: jobId }, "Could not retry media cleanup.");
  // No browser-dependent execution: the scheduled worker consumes the retry.
}
